import React from "react";

import { NavLink } from "react-router-dom";
import Fill from './components/Button/Fill/Index'

const Error = () => {
  return (
    <>
      <div id="notfound" className="p-100 pb-0">
        <div className="container">
          <div className="web-container">
        
        <div className="notfound text-center col-lg-10 m-auto col-12 p-5">
          <div className="notfound-404 mt-5 float-start col-12">
            <h1>404</h1>
          </div>
          <h2>WE ARE SORRY, PAGE NOT FOUND!</h2>
          <p>
            THE PAGE YOU ARE LOOKING FOR MIGHT HAVE BEEN REMOVED HAD ITS NAME
            CHANGED OR IS TEMPORARILY UNAVAILABLE.
          </p>
          <div className="col-12 float-start flex-center">
          <NavLink to="/"><Fill buttonText={'Back to Home'}/></NavLink>
          </div>
        </div>
       
        </div>
        </div>
      </div>
    </>
  );
};

export default Error;
